var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserInquiry2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.79,
    height: 27.05,
    viewBox: "0 0 18.79 27.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-inquiry"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.46 22.62) rotate(-0.55)",
    fontSize: 10,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.46 22.62) rotate(-0.55)",
    fontSize: 10,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.7,6A5.7,5.7,0,0,1,12.4.3,5.76,5.76,0,0,1,18.1,6a5.76,5.76,0,0,1-5.7,5.7A5.7,5.7,0,0,1,6.7,6ZM8.2,6a4.2,4.2,0,1,0,4.2-4.2A4.23,4.23,0,0,0,8.2,6Z",
    transform: "translate(-3.11 -0.21)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,21c0-3.4-3.5-6.2-7.8-6.2S4.7,17.5,4.7,21a.68.68,0,0,1-.7.7.77.77,0,0,1-.8-.7c0-4.3,4.2-7.7,9.3-7.7s9.3,3.5,9.3,7.7a.68.68,0,0,1-.7.7A.71.71,0,0,1,20.3,21Z",
    transform: "translate(-3.11 -0.21)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.11 -0.21)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.11 -0.21)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInquiry2);
export default __webpack_public_path__ + "static/media/user-inquiry2.9159b02d6af71fb5b6cf5b57f1e4147d.svg";
export { ForwardRef as ReactComponent };